module.exports = __webpack_public_path__ + "img/api.da9b89ee.jpg";